<template>
  <div class="material-upload">
    <div class="material-upload-filter">
      <!-- 游戏选项框 -->
      <select-tree
        :value="filter_obj.game_id.value"
        v-bind="filter_obj.game_id.props"
        v-on="filter_obj.game_id.on"
      />
      <!-- 素材类型 -->
      <el-select
        v-model="filter_obj.material_type.value"
        :placeholder="filter_obj.material_type.placeholder"
        size="small"
        style="margin-left: 10px"
        :disabled="!(isSupportSwitchImgType && is_image_material_type)"
        v-on="filter_obj.material_type.on"
      >
        <el-option
          v-for="(item, index) in filter_obj.material_type.options"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <!-- 素材规格 -->
      <el-select
        v-model="filter_obj.material_standard.value"
        :placeholder="filter_obj.material_standard.placeholder"
        size="small"
        style="margin-left: 10px"
        :disabled="Boolean(materialFormatId)"
        v-on="filter_obj.material_standard.on"
      >
        <el-option
          v-for="(item, index) in filter_obj.material_standard.options"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <el-upload
      ref="upload"
      drag
      action=""
      :limit="10"
      :http-request="onSubmitForm"
      :on-exceed="handleFileExceed"
      :on-change="changeUpload"
      :auto-upload="false"
      :show-file-list="false"
      multiple
    >
      <div>
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">
          只能上传{{ file_type }}文件，且不超过{{ material_restriction.max_size }}kb
          <span v-if="material_restriction.min_millisecond && material_restriction.max_millisecond">
            ,时长≥{{ material_restriction.min_millisecond }}s，≤{{ material_restriction.max_millisecond }}s，必须带声音
          </span>
        </div>
      </div>
    </el-upload>
    <div v-show="file_arr.length > 0" class="file-list-box">
      <ul>
        <transition-group name="slide-fade">
          <li v-for="item in file_arr" v-show="item" :key="item.name">
            <div :class="{ item: true, 'pick-on': item.selected }">
              <div
                v-if="item.url"
                class="material-img-bg"
                :style="{ 'background-image': 'url(' + item.url + ')' }"
              />
              <div class="material-img-box">
                <img
                  v-if="item.type === 'image'"
                  :src="item.url"
                  :alt="item.name"
                >
                <video v-if="item.type === 'video'" :src="item.url" controls />
                <div v-if="item.isLoading" class="upload-progress-box">
                  <div class="upload-progress">
                    <el-progress
                      type="circle"
                      :percentage="item.value"
                      :width="50"
                      :status="item.status !== 'ready' ? item.status : null"
                    />
                  </div>
                </div>
              </div>

              <div class="material-label">
                <p>{{ item.name }}</p>
                <p class="file-time">
                  <span v-if="addView.params.second" style="padding-right: 5px; float: left;">
                    <span>截取</span>
                    <div style="display:inline-block">
                      <el-input-number
                        v-model="item.second"
                        style="width: 50px"
                        size="mini"
                        clearable
                        :min="1"
                        :controls="false"
                      />
                    </div>
                    <span>s</span>
                  </span>
                  <span>{{ item.time }}</span>
                </p>
              </div>
            </div>
          </li>
        </transition-group>
      </ul>
    </div>
  </div>
</template>
<script>

// 素材资源
import MaterialResource from '@/api/material/index';
const materialResource = new MaterialResource();

// 获取游戏列表接口
import AdvertisingResource from '@/api/advertising';
const advertisingResource = new AdvertisingResource();

// 素材规格列表接口
import MaterialFormatResource from '@/api/material/format';
const materialFormatResource = new MaterialFormatResource();
export default {
  components: {
    'select-tree': () => import('@/components/select-tree'),
  },
  props: {
    addView: {
      type: Object,
      default: () => {
        return {};
      },
    },
    /** 素材限制 - 支持多个限制条件 */
    restriction: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 素材规格id
    materialFormatId: {
      type: [String, Number],
      default: '',
    },
    /**
     * 是否支持切换图片类型
     * - 单图[image - 1]
     * - 组图[element_story - 4]
     */
    isSupportSwitchImgType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      file_arr: [],
      file_type: '',
      temp_value: 0,
      select_file_arr: [],
      isLoading: false,
      loading_num: 0,
      upload_message: '',
      time: null,
      second: 1,
      temp_load_val: 0,
      is_save: false, // 是否派发保存事件
      // 素材规格列表参数
      material_format_list_params: {
        advertiser: 'jrtt',
        page: 1,
        limit: 10,
      },
      material_format_list: [], // 规格列表
      material_restriction: {}, // 素材限制信息
      // 类型对象
      type_obj: {
        image: 1,
        video: 2,
        element_story: 4,
      },
      filter_obj: {
        // 游戏
        game_id: {
          label: '游戏',
          placeholder: '请选择游戏',
          props: {
            options: [],
            ischeckbox: false,
            'check-on-click-node': true,
            props: {
              value: 'id',
              label: 'name',
              children: 'children',
            },
            'select-props': {
              placeholder: '请选择游戏',
              clearable: true,
              accordion: true,
              size: 'small',
            },
          },
          on: {
            getValue: (game_id) => {
              this.filter_obj.game_id.value = game_id;
            },
          },
          value: null,
        },
        material_type: {
          options: [
            {
              label: '图片',
              value: 1,
            },
            {
              label: '视频',
              value: 2,
            },
            {
              label: '落地页',
              value: 3,
            },
            {
              label: '组图',
              value: 4,
            },
          ],
          value: null,
          on: {
            change: (val) => {
              this.selectMateriaType(val);
            },
          },
        },
        material_standard: {
          label: '素材标准',
          placeholder: '请输入素材标准',
          options: [],
          value: null,
          on: {
            change: (val) => {
              const temp_restriction = this.material_format_list.filter((item) => {
                return item.id === val;
              })[0];

              this.material_restriction = temp_restriction;

              this.file_type = this.material_restriction.mime_type.join('/');
            },
          },
        },
        updata_file: {
          label: '上传素材',
          value: [],
        },
      },
    };
  },
  computed: {
    /**
     * 是否为图片类型素材
     * - 单图[image - 1]
     * - 组图[element_story - 4]
     * @returns {boolean}
     */
    is_image_material_type() {
      const material_type = this.type_obj[this.addView.file_type];
      return [1, 4].includes(material_type);
    },
  },
  created() {
    Object.assign(this.filter_obj.material_type, {
      value: this.type_obj[this.addView.file_type],
      ...((this.isSupportSwitchImgType && this.is_image_material_type) && { options: this.filter_obj.material_type.options.filter(({ value }) => [1, 4].includes(value)) }),
    });
    this.selectMateriaType(this.filter_obj.material_type.value);

    this.getGameList({ is_parent: 0 }).then((res) => {
      for (let i = 0; i < res.list.length; i++) {
        res.list[i]['disabled'] = true;
      }
      this.filter_obj.game_id.props.options = res.list;
    });
  },
  methods: {
    // 上传服务器
    submitUpload(is_save) {
      this.onSubmitForm();
    },
    onUploadImg() {
      this.onOff = true;
    },
    // 选择类型
    selectMateriaType: function(val) {
      this.material_format_list_params['type'] = val;
      this.getMaterialFormatList(this.material_format_list_params).then((res) => {
        this.material_format_list = res.list.map((item) => {
          item.min_millisecond = item.min_millisecond / 1000;
          item.max_millisecond = item.max_millisecond / 1000;
          return item;
        });
        this.filter_obj.material_standard.options = res.list.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });

        // 存在规格ID，默认选中该规格
        if (this.materialFormatId) {
          this.filter_obj.material_standard.value = this.materialFormatId;
          this.filter_obj.material_standard.on.change(this.materialFormatId);
        }
      });
    },
    // 获取素材规格列表
    getMaterialFormatList: function(params) {
      return new Promise((resolve, reject) => {
        materialFormatResource
          .getMaterialFormatListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 超过限制数量事件
    handleFileExceed(files, fileList) {
      this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    // 文件状态改变钩子
    changeUpload(file, fileList) {
      if (!this.filter_obj.game_id.value) {
        this.$message.error('请选择游戏');
        deleFile();
        return;
      }

      if (!this.filter_obj.material_standard.value) {
        this.$message.error('请选择素材规格');
        deleFile();
        return;
      }

      const s = this;
      const item = file;
      this.filter_obj.updata_file.value = fileList;
      const fileReader = new FileReader();
      const d = new Date(item.raw.lastModifiedDate);

      fileReader.readAsDataURL(item.raw);
      item.base64 = '';
      item.isLoading = false;
      item.isUpload = false;
      item.selected = false;
      item.value = 0;
      if (s.addView.params.second) {
        item.second = 1;
      }
      fileReader.onload = () => {
        const base64Str = fileReader.result;
        const isVideo = this.type_obj[s.addView.file_type] === 2;
        const show_file = isVideo ? document.createElement('video') : new Image();
        if (s.verify(item.raw)) {
          if (isVideo) {
            item.type = 'video';
            show_file.addEventListener('loadedmetadata', () => {
              if (show_file.duration < s.material_restriction.min_millisecond || show_file.duration > s.material_restriction.max_millisecond) {
                s.$message.error('视频时长≥' + s.material_restriction.min_millisecond + 's，视频时长≤' + s.material_restriction.max_millisecond + 's');
                return;
              }
              if (!s.verifySize(show_file.videoWidth, show_file.videoHeight)) {
                deleFile();
                return;
              } else {
                s.file_arr = fileList;
              }
              const file_index = fileList.indexOf(item);
              item.name = s.material_restriction.width + 'x' + s.material_restriction.height + '_' + (file_index + 1);
              item.selected = true;
            });
          } else {
            item.type = 'image';
            show_file.onload = () => {
              if (!s.verifySize(show_file.width, show_file.height)) {
                deleFile();
                return;
              } else {
                s.file_arr = fileList;
              }
              const file_index = fileList.indexOf(item);
              item.name = s.material_restriction.width + 'x' + s.material_restriction.height + '_' + (file_index + 1);
              item.selected = true;
            };
          }
        } else {
          deleFile();
          return;
        }

        show_file.src = URL.createObjectURL(item.raw);
        item.url = URL.createObjectURL(item.raw);
        item.base64 = base64Str;
        item.time = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
      };

      function deleFile() {
        const index = fileList.indexOf(file);
        fileList.splice(index, 1);
      }
    },
    // 验证
    verify(file) {
      const is_type = !this.verifyType(file.type);
      const is_file_size = file.size / 1024 < this.material_restriction.max_size;
      let is_corre = true;

      if (!is_type) {
        is_corre = false;
        this.$message.error('上传文件只能是 ' + this.file_type + ' 格式!');
      } else if (!is_file_size) {
        is_corre = false;
        this.$message.error(
          '上传文件大小不能超过 ' + this.material_restriction.max_size + 'kb!'
        );
      }

      return is_corre;
    },
    // 验证限制
    verifyRestriction(temp_restriction) {
      const item = temp_restriction;
      const is_size = this.verifySize(item.width, item.height);
      const is_file_size = item.max_size <= this.material_restriction.max_size;

      if (!is_size) {
        this.$message.error('该规格尺寸不符合要求');
        return false;
      } else if (!is_file_size) {
        this.$message.error('该规格大小不符合要求');
        return false;
      }

      return true;
    },
    // 验证大小尺寸
    verifySize(width, height) {
      let is_size = false;
      const isWidth = width === this.material_restriction.width;
      const isHeigth = height === this.material_restriction.height;
      if (isWidth && isHeigth && isWidth === true && isHeigth === true) {
        is_size = true;
      }
      if (!is_size) {
        this.$message.error('上传文件尺寸大小不符合要求');
      }
      return is_size;
    },
    // 验证文件类型
    verifyType(type) {
      let is_err = true;
      const type_arr =
        this.addView.file_type === 'video'
          ? ['video/mp4', 'video/avi', 'video/mov']
          : ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
      for (var i = 0; i < type_arr.length; i++) {
        const temp_type = type_arr[i];
        if (temp_type === type) {
          is_err = false;
        }
      }
      return is_err;
    },
    // 提交表单
    onSubmitForm: function() {
      const is_submit = true;

      if (is_submit && this.filter_obj.updata_file.value.length > 0) {
        const params = {
          material_type: this.filter_obj.material_type.value,
          is_original: 0,
          game_id: this.filter_obj.game_id.value,
          material_format_id: this.filter_obj.material_standard.value,
          materials: this.filter_obj.updata_file.value.map((item) => {
            return item.raw;
          }),
        };
        const formData = new FormData();
        Object.keys(params).forEach((key) => {
          if (typeof params[key] === 'object') {
            for (const item_key in params[key]) {
              formData.append(key + '[' + item_key + ']', params[key][item_key]);
            }
          } else {
            formData.append(key, params[key]);
          }
        });
        this.updataMaterial(formData).then((res) => {
          this.$emit('select-file', res);
        });
      } else {
        this.$emit('select-file', null);
      }
    },

    // 上传素材
    updataMaterial(params) {
      return new Promise((resolve, reject) => {
        materialResource
          .updataMaterialApi(params)
          .then(response => {
            resolve(response);
            if (response.data && response.data.message) {
              this.$message(response.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 选中文件
    selectFile(file, data, adv_id) {
      file.selected = true;
      for (let i = 0; i < this.select_file_arr.length; i++) {
        const item = this.select_file_arr[i];
        if (item.advertiser_id === adv_id) {
          item.file_list.push(data);
        }
      }
    },
    // 启动进度条
    startProgress(item) {
      const s = this;
      s.stopProgress(item.time_inter);
      item.time_inter = setInterval(() => {
        if (item.value < 99) {
          item.value += 2;
          s.temp_value = item.value;
        } else {
          clearInterval(item.time_inter);
        }
      }, item.size / 1024 / 20);
    },
    // 停止进度条
    stopProgress(time_inter) {
      if (time_inter) {
        clearInterval(time_inter);
        time_inter = null;
      }
    },
    // 更新加载值
    updateVal(item) {
      const s = this;
      if (item.value < 99) {
        item.value += 1;
        s.temp_value = item.value;
      } else {
        clearInterval(item.time_inter);
      }
    },
    // 获取游戏列表
    getGameList: function(params) {
      return new Promise((resolve, reject) => {
        advertisingResource
          .getGameListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
</script>
<style scoped rel="stylesheet/scss" lang="scss">
.material-upload {
  .material-upload-filter {
    padding-bottom: 20px;
  }
  .file-list-box {
    width: 100%;
    height: 300px;
    overflow-y: auto;
    margin-top: 10px;
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        width: 20%;
        padding: 0 8px;
        margin: 0 0 30px;
        float: left;
        .item.pick-on {
          border: 2px #2096f5 solid;
        }
        .item {
          position: relative;
          .material-img-bg {
            position: absolute;
            width: 100%;
            height: 200px;
            background-size: auto 200px;
            opacity: 0.4;
            -webkit-filter: blur(10px);
            filter: blur(10px);
          }
          .material-img-box {
            position: relative;
            width: 100%;
            padding: 10px;
            height: 200px;
            img,
            video {
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              max-width: 100%;
              max-height: 100%;
              margin: auto;
            }
            .upload-progress-box {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: rgba($color: #000000, $alpha: 0.5);
              .upload-progress {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                margin: auto;
                .el-progress__text {
                  color: #fff;
                }
              }
            }
          }

          .material-label {
            line-height: 15px;
            padding: 0 10px;
            .file-time {
              color: #aaa;
              text-align: right;
              line-height: 30px;
            }
          }
        }
      }
    }
  }
}

/*切换路由动画--------*/
.slide-fade {
  position: absolute;
  left: 0;
  right: 0;
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s ease;
}

.slide-fade-enter-to,
.slide-fade-leave {
  opacity: 1;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(50px);
  opacity: 0;
}
</style>
